<section class="child">
    <c-offline-form-message type="'CaseflowConfig'" is-competency="true" />
</section>
<section class="child">
    <c-tree-explorer config="vm.shortcutsConfig"></c-tree-explorer>
</section>
<section class="child">
    <c-tree-explorer config="vm.assignmentTaskShortcuts"></c-tree-explorer>
</section>